export const isProd = process.env.NODE_ENV === 'production'
const isProdMode = process.env.PROD_MODE === 'prod'
// 默认baseUrl
export const BASE_API = function() {
  // return baseIp + `:${port}`
  return isProd ? 'crm-app' : 'huigou'
}

// 下载地址
export const DOWNLOAD_API = function() {
  return '/huigou'
}

export const URLS = {
  // 公关团购定制酒显示
  GGTG_DZJURL: isProd ? 'https://yingxiao.wuliangye.com.cn:8081/dpss' : 'http://10.0.134.120:9031/distributor',
  // 流程图
  FOLLOW_URL: isProd ? '/gateway/' : 'http://10.0.135.61/gateway/',
  // http://10.0.134.118:8080/upload
  QY_URL: isProdMode ? 'https://yingxiao.wuliangye.com.cn/wmdp-uploadfile/upload': 'http://10.0.134.118:8080/upload', //内网生产
  // QY_URL: isProdMode ? 'https://yingxiao.wuliangye.com.cn/wmdp-uploadfile/upload' : 'https://uat.wuliangye.com.cn/wmdp-uploadfile/upload', //测试环境
  QY_DELEURL: 'http://10.0.134.118:8080/delete', //生产
  // QY_DELEURL: isProdMode ? 'https://yingxiao.wuliangye.com.cn/wmdp-uploadfile/delete' : 'https://uat.wuliangye.com.cn/wmdp-uploadfile/delete', //测试环境
}




// WEBPACK FOOTER //
// ./src/api/baseUrl.js